export default __webpack_public_path__ + "static/media/426.1c67cc92.png";